import React from "react";

const COLORS = {
  processed: { bg: "bg-emerald-50", text: "text-emerald-800", ring: "ring-emerald-200", dot: "bg-emerald-500" },
  error:     { bg: "bg-rose-50",    text: "text-rose-800",    ring: "ring-rose-200",    dot: "bg-rose-500" },
  skipped:   { bg: "bg-amber-50",   text: "text-amber-800",   ring: "ring-amber-200",   dot: "bg-amber-500" },
  pending:   { bg: "bg-blue-50",    text: "text-blue-800",    ring: "ring-blue-200",    dot: "bg-blue-500" },
  completed: { bg: "bg-emerald-50", text: "text-emerald-800", ring: "ring-emerald-200", dot: "bg-emerald-500" },
  unknown:   { bg: "bg-zinc-100",   text: "text-zinc-700",    ring: "ring-zinc-200",    dot: "bg-zinc-400" },
};

export function StatusBadge({ status, className = "" }) {
  const key = (status || "unknown").toLowerCase();
  const c = COLORS[key] || COLORS.unknown;
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium ring-1 ring-inset ${c.bg} ${c.text} ${c.ring} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${c.dot}`} />
      {status || "unknown"}
    </span>
  );
}
